import React, { useEffect } from 'react';
import './assets/styles/auth.scss';
import { useDispatch } from 'react-redux';
import { removeCredentials, removeLicence, removeDelegatedUser } from './authSlice';
import posthog from '../../analytics/posthog';
import { trackLogout } from '../../analytics/track';

export const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const doLogout = async () => {
      // Only ask the server to clear the release-channel canary when this session
      // is on beta - otherwise the round-trip is unnecessary for stable users.
      const hasBetaReleaseChannel = document.cookie
        .split(';')
        .some((c) => c.trim() === 'release-channel=beta');

      if (hasBetaReleaseChannel) {
        try {
          // Clears the release-channel canary cookie server-side so a browser that
          // logged in as a beta-tester is not routed to beta on later logins.
          await fetch(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {
            method: 'POST',
            credentials: 'include',
          });
        } catch (e) {
          // Best-effort - local logout must proceed regardless.
        }

        // Also expire the client-readable cookie so it is gone from this origin.
        const expired = '; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        document.cookie = `release-channel=${expired}`;
        document.cookie = `release-channel=${expired}; domain=${globalThis.location.hostname}`;
      }
      dispatch(removeCredentials());
      dispatch(removeLicence());
      dispatch(removeDelegatedUser());
      // Capture the event before reset so it is still attributed to the correct
      // person. reset() clears the distinct_id, so order matters here.
      trackLogout();
      posthog.reset();
      globalThis.location.href = '/';
    };
    doLogout();
  }, [dispatch]);

  return <i>processing...</i>;
};
